export class changePassword {
    _id: string;
    previous_password: string;
    new_password: string;
    new_password_repeat: string;
}